module.exports = __webpack_public_path__ + "static/media/computer.97963f48.jpg";